import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { SectionTitle } from "../kit";
import { SweepWord } from "../motion";
import { useLocales } from "../../core/i18n";
import { INFO, useSiteSettings } from "../../core/site";
import ContactFacts from "./ContactFacts";
import { CONTAINER, SECTION_PAD, TITLE_TO_CONTENT } from "./layout";

/** Showcase hello, the caller's own pitch, or the default services pitch. */
function choosePitch(props, openToWork, t) {
	if (!openToWork) {
		return {
			title: t("showcase.ctaTitle"),
			highlight: t("showcase.ctaHighlight"),
			description: t("showcase.ctaDescription"),
		};
	}
	if (props.title) return props;
	return {
		title: t("services.ctaTitle"),
		highlight: t("services.ctaTitleHighlight"),
		description: t("services.ctaDescription"),
	};
}

/**
 * The closing block on every page: a pitch, the contact actions and the
 * practical facts, on the ink slab.
 *
 * Without a `title` it pitches the services (services.cta*); pages with
 * their own pitch pass title/highlight/description. Showcase mode (open to
 * work off) replaces any pitch with a plain hello, in this one place.
 */
const ContactSlab = (props) => {
	const { t } = useLocales();
	const { openToWork } = useSiteSettings();
	const pitch = choosePitch(props, openToWork, t);

	return (
		<section className={`bg-pp-ink ${SECTION_PAD}`}>
			<div className={CONTAINER}>
				<SectionTitle dark description={pitch.description}>
					{pitch.title}
					{pitch.highlight && (
						<>
							{" "}
							<SweepWord>{pitch.highlight}</SweepWord>
						</>
					)}
				</SectionTitle>
				<div
					className={`${TITLE_TO_CONTENT} grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16`}
				>
					{/* The site's own contact route is the primary action; LinkedIn is the alternative. */}
					<div className="lg:col-span-8">
						<div className="flex flex-col sm:flex-row gap-4">
							<Link to="/contact" className="pp-btn-dark">
								{t("hero.ctaContact")}
							</Link>
							<a
								href={INFO.socials.linkedin.link}
								target="_blank"
								rel="noopener noreferrer"
								className="pp-btn-ghost-dark"
							>
								{t("hero.ctaLinkedIn")}
							</a>
						</div>
					</div>
					<ContactFacts openToWork={openToWork} />
				</div>
			</div>
		</section>
	);
};

ContactSlab.propTypes = {
	/** Defaults to the services pitch (services.ctaTitle and friends). */
	title: PropTypes.node,
	highlight: PropTypes.string,
	description: PropTypes.string,
};

export default ContactSlab;
